'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const components_display_Icon_Icon = require('../Icon/Icon.cjs.js');

const tableHeadSortButton = "_table-head-sort-button_1xs64_1";
const styles = {
	tableHeadSortButton: tableHeadSortButton
};

const TableHeadSortButton = (props) => {
  return jsxRuntime.jsxs("button", { type: "button", className: styles.tableHeadSortButton, onClick: props.onClick, "data-zds": true, children: [props.children, jsxRuntime.jsx(components_display_Icon_Icon.Icon, { color: "GrayWarm6", name: "arrowDropdown", size: 16 })] });
};

exports.TableHeadSortButton = TableHeadSortButton;
//# sourceMappingURL=TableHeadSortButton.cjs.js.map
